import canUseDOM from '../common/canUseDom';

const newRelicNoticeError = (err) => {
  if (canUseDOM && window.newrelic) {
    window.newrelic.noticeError(err);
  }
};

export default newRelicNoticeError;



// WEBPACK FOOTER //
// ./src/utils/newRelic.js